import { isEmpty, isNumber } from 'lodash/lang'
import { map } from 'lodash/collection'

const createValidator = rules => label => map(rules, rule => rule(label))

const rules = {
	number: label => val => {
		const numVal = Number(val)
		if (!isNumber(numVal) || Number.isNaN(numVal)) {
			return `${label} should be number`
		}
		return null
	},
	nonNull: label => val => {
		if (isEmpty(val)) {
			return `${label} cannot be empty`
		}
		return null
	}
}

const id = createValidator([rules.nonNull, rules.number])

const nullableID = createValidator([rules.number])

const required = createValidator([rules.nonNull])

const validator = { id, required, nullableID }

export const ValidatorPlugin = {
	install(Vue) {
		Vue.prototype.$validator = validator
	}
}
